














import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModule,
  InstallationModuleData,
  Material,
  MechanicInstallation,
  StatusFlags
} from "@/types";
import { isItemRequired } from "@/utilities";

import SerialnumbersManager from "@/containers/serialnumbers-manager";

import Vue, { PropType } from "vue";
import { InstallationModuleStatus } from "@/store/modules/installation";

export default Vue.extend({
  components: {
    SerialnumbersManager
  },

  props: {
    installation: { type: Object as PropType<MechanicInstallation> },
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    module: { type: Object as PropType<InstallationModule> }
  },

  computed: {
    isRequired(): boolean {
      const documentData: DynamicDocumentItemData[] = [
        { field: this.item.field, value: undefined }
      ];
      return isItemRequired(this.item, documentData, this.moduleData);
    },

    flags(): StatusFlags {
      return this.module.flags || {};
    },

    meters(): Material[] {
      return this.$store.state.materials.meters.items;
    },

    patterns(): string[] {
      return this.meters.flatMap(meter => meter.types?.flatMap(type => type.patterns ?? []) ?? []);
    },

    isProcessing(): boolean {
      return this.status.status === "processing";
    },

    status(): InstallationModuleStatus {
      return this.$store.getters["installation/status"](this.installation.id, this.module.type);
    },

    meterType(): string[] {
      const documentData = this.$store.getters["deliveryDocuments/data"](
        this.installation.id,
        this.module.type
      );
      return documentData.find((item: DynamicDocumentItemData) => item.field === "meterType")
        ?.value;
    }
  },

  mounted() {
    this.checkType();
  },

  destroyed() {
    this.checkType();
  },

  methods: {
    checkType() {
      const documentData = this.$store.getters["deliveryDocuments/data"](
        this.installation.id,
        this.module.type
      );
      const meterType = documentData.find(
        (item: DynamicDocumentItemData) => item.field === "meterType"
      );

      const snWocozon = this.moduleData.meterSerialNumbers?.[0]?.serialNumber;
      const snEnphaseGateway = this.moduleData.meterSerialNumbersEnphaseGateway?.[0]?.serialNumber;
      const snEnphaseRelay = this.moduleData.meterSerialNumbersEnphaseRelay?.[0]?.serialNumber;

      let serialNumber;

      if (this.meterType?.includes("Wocozon") && meterType?.value?.includes("Enphase")) {
        serialNumber = snWocozon || snEnphaseGateway || snEnphaseRelay;
      } else if (this.meterType?.includes("Enphase")) {
        serialNumber = snEnphaseGateway || snEnphaseRelay;
      } else {
        serialNumber = snWocozon;
      }

      let meterId = null;

      if (serialNumber) {
        const type = this.$store.getters["materials/meters/findItemBySn"](serialNumber);
        meterId = type?.id || null;
      }

      if (this.moduleData.meterId !== meterId) {
        this.$set(this.moduleData, "meterId", meterId);
      }
      this.save();
    },

    save() {
      this.$emit("save:module");
      this.$emit("save:document");
    }
  }
});
